<script>
    import { selectedGroup } from '../../store';
    import { Spinner, Table } from 'sveltestrap';
    import TableColumn from '../../components/TableColumn.svelte';   
    import http from '../../api/http.js';
    export let computerId;
    let networkAdapters = [];

    $: {    
      computerId;
      loadNetworkAdapters()
    }

    async function loadNetworkAdapters(columnValue, sortTypeArg){
        let ascending = sortTypeArg == sortType.ascending ? true : false;

        if(columnValue == undefined){
            columnValue = 0;
        }

        if(ascending == undefined){
            ascending = true;
        }

        const res = await http.get(`${window.apiBaseUrl}/deploy/dashboard/computers/networkadapters/${computerId}/${$selectedGroup}/${columnValue}/${ascending}`);

        if(res.status == 200){
            networkAdapters = await res.json();
        }
        else{
            networkAdapters = [];
        }
    }

    let sortType = {
      ascending: 'ascending',
      descending: 'descending',
      resting: 'resting'
    }

    let activeColumn = {
    columnValue: 0,
    sortType: sortType.ascending,
  };

    function toggleSort(columnValue, theSortType){
        if(activeColumn.value != columnValue){
            activeColumn.columnValue = columnValue;    
        }

        switch(theSortType){
        case sortType.resting:   
            activeColumn.sortType = sortType.ascending;  
            break;
        case sortType.ascending:
            activeColumn.sortType = sortType.descending;
            break;
        case sortType.descending:
            activeColumn.sortType = sortType.ascending;
            break;
        }

        if(activeColumn.sortType != sortType.resting){
            loadNetworkAdapters(columnValue, activeColumn.sortType);
        }
        else{
            activeColumn.columnValue = 0;
            activeColumn.sortType = sortType.ascending;
            loadNetworkAdapters(0, activeColumn.sortType);
        }
    }
</script>

{#await loadNetworkAdapters(activeColumn.columnValue, activeColumn.sortType)}
    <Spinner color="primary" type="border"></Spinner>
{:then}
    <Table responsive>
        <thead>    
            <TableColumn on:mousedown={() => toggleSort(0, activeColumn.sortType)} active={activeColumn.columnValue == 0} sortType={activeColumn.sortType}>Description</TableColumn>
            <TableColumn on:mousedown={() => toggleSort(1, activeColumn.sortType)} active={activeColumn.columnValue == 1} sortType={activeColumn.sortType}>MAC Address</TableColumn>
            <TableColumn on:mousedown={() => toggleSort(2, activeColumn.sortType)} active={activeColumn.columnValue == 2} sortType={activeColumn.sortType}>IPV4 Addresses</TableColumn>
            <TableColumn on:mousedown={() => toggleSort(3, activeColumn.sortType)} active={activeColumn.columnValue == 3} sortType={activeColumn.sortType}>IPV4 Subnets</TableColumn>
            <TableColumn on:mousedown={() => toggleSort(4, activeColumn.sortType)} active={activeColumn.columnValue == 4} sortType={activeColumn.sortType}>IPV6 Addresses</TableColumn>
            <TableColumn on:mousedown={() => toggleSort(5, activeColumn.sortType)} active={activeColumn.columnValue == 5} sortType={activeColumn.sortType}>IPV6 Subnets</TableColumn>
            <TableColumn on:mousedown={() => toggleSort(6, activeColumn.sortType)} active={activeColumn.columnValue == 6} sortType={activeColumn.sortType}>DHCP Enabled</TableColumn>
            <TableColumn on:mousedown={() => toggleSort(7, activeColumn.sortType)} active={activeColumn.columnValue == 7} sortType={activeColumn.sortType}>DNS Domain</TableColumn>
            <TableColumn on:mousedown={() => toggleSort(8, activeColumn.sortType)} active={activeColumn.columnValue == 8} sortType={activeColumn.sortType}>DNS Host Name</TableColumn>
        </thead>
        <tbody>
            {#if networkAdapters.length > 0}
                {#each networkAdapters as adapter}
                    <tr id="network-adapter-row-{adapter.id}">
                        <td>{adapter.description}</td>
                        <td>{adapter.macAddress}</td>
                        <td>
                            {#each adapter.ipV4Addresses as ipv4Address}
                                <p>{ipv4Address}</p>
                            {/each}
                        </td>
                        <td>
                            {#each adapter.ipV4Subnets as ipv4Subnet}
                                <p>{ipv4Subnet}</p>
                            {/each}
                        </td>
                        <td>
                            {#each adapter.ipV6Addresses as ipv6Address}
                                <p>{ipv6Address}</p>
                            {/each}
                        </td>
                        <td>
                            {#each adapter.ipV6Subnets as ipv6Subnet}
                                <p>{ipv6Subnet}</p>
                            {/each}
                        </td>
                        <td>{adapter.dhcpEnabled}</td>
                        <td>{adapter.dnsDomain}</td>
                        <td>{adapter.dnsHostName}</td>
                    </tr>     
                {/each}
            {:else}
                <tr>
                    <td colspan="7" class="text-center">No Network Adapters Found</td>
                </tr>
            {/if}
        </tbody>
    </Table>
{/await}

<style>

</style>